<template>
  <AuthComponent @result="handleAuth"/>

  <v-navigation-drawer color="primary">
    <v-list-item title="Dan's Tech Services" subtitle="Techs" />
    <v-divider color="white"></v-divider>
    <v-list-item v-if="auth" link title="Dashboard" to="/"/>
    <v-list-item v-if="auth" link title="Customers" to="/customers"/>
    <v-list-item v-if="auth" link title="Tickets" to="/tickets"/>
    <v-list-item v-if="auth" link title="Devices" to="/devices"/>
    <v-list-item v-if="auth" link title="Alerts" to="/alerts"/>
    <v-list-item v-if="auth" link title="Plans" to="/plans"/>
    <v-list-item v-if="auth" link title="Billing" to="/billing"/>
    <v-list-item v-if="auth" link title="Admin" to="/admin"/>
    <v-list-item link :title="auth ? 'Logout' : 'Login'" to="/login"/>
  </v-navigation-drawer>
</template>
  
  <script>
  import AuthComponent from './AuthComponent.vue';
  import { defineComponent } from 'vue';
  
  // Components
  
  export default defineComponent({
    name: 'NavDrawer',

    components:{
      AuthComponent
    },
  
    data: () => ({
      auth : null
    }),

    methods:{
      handleAuth(auth){
        this.auth = auth;
      }
    }
  });
  </script>
  